import { Button, Form, Heading, Row, Col, Text } from 'components';
import { styled } from 'mymoria-ui';
import React, { FunctionComponent, useState, ChangeEvent } from 'react';

interface Props {
  /**
   * Tile title.
   */
  title?: string;

  /**
   * Tile Description.
   */
  description?: string;

  /**
   * confirm Button Label.
   */
  confirmButtonText: string;

  /**
   * cancel Button Label.
   */
  cancelButtonText: string;

  /**
   * textarea Label.
   */
  textareaLabel: string;

  /**
   * hide Modal
   */
  hideModal: () => void;

  /**
   * Note Value
   */
  graveTypeNote?: string;

  /**
   * Note example text
   */
  noteExample?: string;
}

const StyledRow = styled(Row)`
  z-index: 8;
`;

const StyledCol = styled(Col)`
  margin: 0 0 2.5rem;
`;

const FlexCol = styled(Col)`
  display: flex !important;
  justify-content: flex-end;
`;

const CancelButton = styled(Button)`
  margin-right: 2rem;
`;

const NoteModal: FunctionComponent<Props> = ({
  title,
  confirmButtonText,
  cancelButtonText,
  textareaLabel,
  hideModal,
  graveTypeNote,
  noteExample,
}) => {
  const [graveNote, setGraveNote] = useState(graveTypeNote);

  const handleGraveNoteChange = (event: ChangeEvent<HTMLTextAreaElement>) =>
    setGraveNote(event.target.value);

  return (
    <StyledRow flexDirection="column">
      <StyledCol width={[1, null, 1 / 2]}>
        <Heading.Heading1 className="modal_title">{title}</Heading.Heading1>
        <Text>{noteExample}</Text>
      </StyledCol>
      <StyledCol width={1}>
        <Form.Textarea
          rows={8}
          onChange={handleGraveNoteChange}
          value={graveNote}
          label={textareaLabel}
        />
      </StyledCol>
      <FlexCol width={1}>
        <CancelButton className="cancel_btn" onClick={hideModal} ghost>
          {cancelButtonText}
        </CancelButton>
        <Button className="create_btn">{confirmButtonText}</Button>
      </FlexCol>
    </StyledRow>
  );
};

export default NoteModal;
